var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c_single"},[_c('div',{staticClass:"c_single_movie"},[_c('div',{staticClass:"pt-3"},[(_vm.isShokai)?_c('survey-content-shokai'):_c('survey-content')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }